module.exports = __webpack_public_path__ + "assets/retina_4SymmetricLinesDetailed.8d1fe849c01034decc9dd71a96b20f34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_4SymmetricLinesDetailed.png
// module id = 601
// module chunks = 0